import { Component, inject, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { StyleClassModule } from 'primeng/styleclass';
import { Popover } from 'primeng/popover';
import { DatePicker } from 'primeng/datepicker';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { Tag } from 'primeng/tag';
import { AppConfigurator } from './app.configurator';
import { AppBrandLogo } from './app.brand-logo';
import { AiAssistStatus } from './ai-assist-status';
import { LayoutService } from '@/app/layout/service/layout.service';
import { AuthService } from '@/app/services/auth.service';

/**
 * Topbar shell: menu toggle, wordmark, theme controls and the profile / logout
 * flow. The AI Assist indicator and the logo live in their own components.
 */
@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [
        RouterModule,
        NgClass,
        FormsModule,
        StyleClassModule,
        AppConfigurator,
        AppBrandLogo,
        AiAssistStatus,
        Popover,
        DatePicker,
        Button,
        Dialog,
        Tag,
    ],
    templateUrl: './app.topbar.html',
})
export class AppTopbar {
    protected readonly layoutService = inject(LayoutService);
    protected readonly authService = inject(AuthService);

    protected readonly calendarDate = signal<Date>(new Date());
    protected readonly logoutDialogVisible = signal(false);

    protected toggleDarkMode(): void {
        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: !state.darkTheme,
        }));
    }

    protected logout(): void {
        this.authService.logout();
    }
}
